import { useMemo } from 'react'

import 'reactflow/dist/style.css'

import { Node } from 'dagre'
import { Edge } from 'reactflow'

import { IItemTraceability } from '../../../sdk/traceability/traceability.types'
import { ItemNode } from '../components/ItemNode/item-node.comp'

const nodeExists = (nodeId: string, traceability: IItemTraceability[]) => {
  return !!traceability.find((i) => i.id === nodeId)
}

const getInitialData = (traceability: IItemTraceability[]) => {
  const initialNodes: Node<any>[] = []
  traceability.forEach((item) => {
    initialNodes.push({
      id: item.id,
      position: { x: 0, y: 0 },
      data: item,
      type: 'default',
    })
  })

  const initialEdges: Edge<any>[] = []
  traceability.forEach((item) => {
    item.nextItems
      .filter((nextItem) => nodeExists(nextItem, traceability))
      .forEach((nextItem) => {
        initialEdges.push({
          id: `edge-$${item.id}-${nextItem}}`,
          source: item.id,
          target: nextItem,
          animated: true,
          style: {
            stroke: '#c8c8c8',
            strokeWidth: 2,
          },
        })
      })
  })

  return {
    nodes: initialNodes,
    edges: initialEdges,
  }
}

interface IUseAuditItemTree {
  traceability?: IItemTraceability[]
}

export const useAuditItemTree = ({ traceability }: IUseAuditItemTree) => {
  const initialData = useMemo(() => {
    if (traceability) {
      return getInitialData(traceability)
    }

    return {
      nodes: [],
      edges: [],
    }
  }, [traceability])

  const { nodes: initialNodes, edges: initialEdges } = initialData

  // According to the documentation this optimizes the rendering of nodes
  const nodeTypes = useMemo(() => ({ default: ItemNode }), [])

  return {
    initialNodes,
    initialEdges,
    nodeTypes,
  }
}
